import { StoreState } from '../../types';

export const getIsOpened = (state: StoreState): boolean =>
  state.reAcceptConfirmModal.isOpened;
